<template>
  <v-dialog v-model="popup.show" max-width="500px" transition="slide-y-reverse-transition" persistent scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar class="pl-2" color="transparent" flat>
          <v-spacer></v-spacer>
          <v-toolbar-title class="headline ml-4">{{popup.type}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click.native="popup.show = false"
            :disabled="popup.type == 'Done' || popup.type == 'Adding Tag'"
            icon
            flat
          ><v-icon>close</v-icon></v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-layout row wrap>
          <v-flex v-if="popup.type == 'Done'" xs12 class="text-xs-center px-3 pb-3 pt-1">
            <div class="title pb-2">Question added</div>
            <div class="title pb-3">Add another question?</div>
            <div>
              <v-btn @click.native="broadcast('reset')" color="success" depressed>Yes</v-btn>
              <v-btn @click.native="broadcast('done')" color="error" flat><b>No</b></v-btn>
            </div>
          </v-flex>
          <v-flex v-if="popup.type == 'Resetting'" xs12 class="text-xs-center px-3 pb-3 pt-1">
            <div class="title pb-2">You will lose all unsaved changes</div>
            <div class="title pb-3">Are you sure?</div>
            <div>
              <v-btn @click.native="broadcast('reset')" color="error" depressed>Reset</v-btn>
            </div>
          </v-flex>
          <v-flex v-if="popup.type == 'Warning'" xs12 class="text-xs-center px-3 pb-3 pt-1">
            <div class="title pb-2">There may be no tags selected</div>
            <div class="title pb-2">There may be no rationale entered</div>
            <div class="title pb-3">Continue anyway?</div>
            <div>
              <v-btn @click.native="broadcast('addQuestion')" color="success" depressed>Continue</v-btn>
            </div>
          </v-flex>
          <v-flex v-if="popup.type == 'Deleting Answer'" xs12 class="text-xs-center px-3 pb-3 pt-1">
            <div class="title pb-2">Selected answer will be deleted</div>
            <div class="title pb-3">Are you sure?</div>
            <div>
              <v-btn @click.native="broadcast('removeAnswer')" color="error" depressed>Delete</v-btn>
            </div>
          </v-flex>
          <v-flex v-if="popup.type == 'Tags'" xs12 class="text-xs-center px-3 pb-3 pt-1">
            <div class="title pb-3">
              <v-text-field
                label="New Tag"
                v-model.trim="newTag"
                @keyup.enter="(newTag.length > 1) ? popup.type = 'Adding Tag' : popup.type = 'Tags'"
                hide-details
              ></v-text-field>
              <v-btn 
                @click.native="(newTag.length > 1) ? popup.type = 'Adding Tag' : popup.type = 'Tags'" 
                color="success" 
                :disabled="!(newTag.length > 1)"
                depressed
                small
              >Add</v-btn>
            </div>
            <div class="text-xs-center pb-2">
              <div class="subheading pb-1"><b>All Available Tags ({{allTags.length}})</b></div>
              <span v-if="allTags.length > 0">
                <v-chip
                  v-for="tag, index in allTags"
                  :key="tag"
                  class="subheading mt-0 mb-1"
                >{{tag}}</v-chip>
              </span>
              <span v-else class="subheading grey--text text--lighten-1">None</span>
            </div>
          </v-flex>
          <v-flex v-if="popup.type == 'Adding Tag'" xs12 class="text-xs-center px-3 pb-3 pt-1">
            <div class="title pb-2">Adding <v-chip>{{newTag}}</v-chip> as a Tag</div>
            <div class="title pb-2">This action cannot be reversed</div>
            <div class="title pb-3">Continue?</div>
            <div>
              <v-btn @click.native="addTag" color="success" depressed>Add</v-btn>
              <v-btn @click.native="popup.type = 'Tags'" color="error" flat><b>Back</b></v-btn>
            </div>
          </v-flex>
          <v-flex v-if="popup.type == 'NCLEX Areas'" xs12 class="text-xs-center px-3 pb-3 pt-1">
            <div class="title pb-3">
              <v-text-field
                label="New NCLEX Area"
                v-model.trim="newArea"
                @keyup.enter="(newArea.length > 1) ? popup.type = 'Adding NCLEX Area' : popup.type = 'NCLEX Areas'"
                hide-details
              ></v-text-field>
              <v-btn 
                @click.native="(newArea.length > 1) ? popup.type = 'Adding NCLEX Area' : popup.type = 'NCLEX Areas'" 
                color="success" 
                :disabled="!(newArea.length > 1)"
                depressed
                small
              >Add</v-btn>
            </div>
            <div class="text-xs-center pb-2">
              <div class="subheading pb-1"><b>All Available NCLEX Areas ({{nclexAreas.length}})</b></div>
              <span v-if="nclexAreas.length > 0">
                <v-chip
                  v-for="area in nclexAreas"
                  :key="area"
                  class="subheading mt-0 mb-1"
                >{{area}}</v-chip>
              </span>
              <span v-else class="subheading grey--text text--lighten-1">None</span>
            </div>
          </v-flex>
          <v-flex v-if="popup.type == 'Adding NCLEX Area'" xs12 class="text-xs-center px-3 pb-3 pt-1">
            <div class="title pb-2">Adding <v-chip>{{newArea}}</v-chip> as a NCLEX Area</div>
            <div class="title pb-2">This action cannot be reversed</div>
            <div class="title pb-3">Continue?</div>
            <div>
              <v-btn @click.native="addArea" color="success" depressed>Add</v-btn>
              <v-btn @click.native="popup.type = 'NCLEX Areas'" color="error" flat><b>Back</b></v-btn>
            </div>
          </v-flex>
          <v-flex v-if="popup.type == 'Deleting Question'" xs12 class="text-xs-center px-3 pb-3 pt-1">
            <div class="title pb-2"><b>{{'Question ' + questionId}}</b> will be deleted</div>
            <div class="title pb-3">This action cannot be reversed</div>
            <div class="title pb-3">Continue?</div>
            <div>
              <v-btn @click.native="broadcast('deleteQuestion')" color="error" depressed>Delete</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['popup', 'allTags', 'questionId', 'nclexAreas'],
  data: () => ({
    newTag: '',
    newArea: ''
  }),
  methods: {
    broadcast (event) {
      this.$emit(event)
      this.popup.show = false
    },
    addTag () {
      this.$emit('addTag', this.newTag)
      this.newTag = ''
    },
    addArea () {
      this.$emit('addArea', this.newArea)
      this.newArea = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/questions/QuestionPopup.vue